import React from "react";
import PropTypes from "prop-types";
import * as Styled from "./styles/StyledResponsiveTitle";

export const ResponsiveTitle = props => <Styled.ResponsiveTitle {...props}>{props.children}</Styled.ResponsiveTitle>;
export const ResponsiveH1 = props => <Styled.ResponsiveH1 {...props}>{props.children}</Styled.ResponsiveH1>;
export const ResponsiveH2 = props => <Styled.ResponsiveH2 {...props}>{props.children}</Styled.ResponsiveH2>;
export const ResponsiveH3 = props => <Styled.ResponsiveH3 {...props}>{props.children}</Styled.ResponsiveH3>;
export const ResponsiveH4 = props => <Styled.ResponsiveH4 {...props}>{props.children}</Styled.ResponsiveH4>;
export const ResponsiveH5 = props => <Styled.ResponsiveH5 {...props}>{props.children}</Styled.ResponsiveH5>;
export const ResponsiveH6 = props => <Styled.ResponsiveH6 {...props}>{props.children}</Styled.ResponsiveH6>;

ResponsiveTitle.propTypes = {
  children: PropTypes.any
};
ResponsiveH1.propTypes = {
  children: PropTypes.any
};
ResponsiveH2.propTypes = {
  children: PropTypes.any
};
ResponsiveH3.propTypes = {
  children: PropTypes.any
};
ResponsiveH4.propTypes = {
  children: PropTypes.any
};
ResponsiveH5.propTypes = {
  children: PropTypes.any
};
ResponsiveH6.propTypes = {
  children: PropTypes.any
};



// WEBPACK FOOTER //
// ./src/components/Title/Title.js